export function isInShadow(el: Element) {
  return el.getRootNode() instanceof ShadowRoot;
}
